// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorMessage_errorMessage__-Qqwj"};